import React from "react";
import pl from "../../images/pinelabs-logo.png";
import "../../css/style.css";
import { connect } from "react-redux";
import Navigation from "../Navigation/Navigation";
import MerchantPaymentDataUtils from "../../utils/MerchantPaymentDataUtils";
import Loader from "react-loader-spinner";
import PopUp from "../HOC/PopUp";
import { FETCHING_MERCHANT_PAYMENT_DATA_BEGINS } from "../../stores/actions/CommonAction";
import { formatNumber, ConvertValueToPercent } from "../Common/Function";
class EmiDetails extends React.Component {
  constructor(props) {
    super(props);
  }

  onClickedClose = () => { };
  render() {
    const {conveniencefee_data,is_IRCTC}=this.props;
    let tenureData = this.props.tenureData;
    let dynamicItemLevelEMIdetails = null;
    this.is_IRCTC = this.props.is_IRCTC;
    const isSplitEmi = this.props.isSplitEmi;

    if (tenureData != null && tenureData.offer_scheme != null) {
      let arrproductDetails = tenureData.offer_scheme.product_details;
      let tenuerMonths = tenureData.tenure_in_month;
      if (arrproductDetails != null && arrproductDetails.length > 0) {
        dynamicItemLevelEMIdetails = arrproductDetails.map(pd => {
          debugger;
          let defaultValue = 0;
          let conveniencefee = 0;
          let product_amount =0;
          product_amount = pd.product_amount ?? defaultValue;
          pd.bank_interest_rate = pd.bank_interest_rate ?? defaultValue;
          pd.product_discount = pd.product_discount ?? defaultValue;
          pd.subvention_cashback_discount = pd.subvention_cashback_discount ?? defaultValue;
          pd.additional_cashback = pd.additional_cashback ?? defaultValue;
          return (
            <div class="col-12 paymentSummaryDetail">

              {pd.product_display_name == 'NO_PRODUCT_DISPLAY_NAME' ? null :
                <div class="row emi-product-details-title">
                  <div class="col-7 text-left">
                    <p>{pd.product_display_name}</p>
                  </div>
                  {/* <div class="col-5 text-right">
                  <p>Qty: 1</p>
                </div> */}
                </div>}
              <div class="row emi-product-details">
                <div class="col-7 text-left">
                  <p>{this.is_IRCTC ? 'Ticket Fare':'Item value'}</p>
                </div>
                <div class="col-5 text-right">
                  <p class="">₹{" "}{formatNumber(product_amount/ 100) }</p>
                </div>
              </div>
              <div class="row emi-deferred-total-amount">
                <div class="col-7 text-left">
                  <p>Interest {`(${tenureData.bank_interest_rate / 10000} % p.a.)`}</p>
                </div>
                <div class="col-5 text-right">
                  <p class="">₹{" "}{formatNumber(pd.bank_interest_rate / 100)}</p>
                </div>
              </div>
              <div class="row deferred-text">{`(Charged by the bank)`}</div>
              {isSplitEmi ? <>
              <div class="row emi-deferred-total-amount">
                <div class="col-7 text-left">
                  <p class="text-green">Deferred Amount ({ConvertValueToPercent(tenureData.deferred_percentage)}%)</p>
                </div>
                <div class="col-5 text-right">
                  <p class="text-green">

                    -{" "}₹{" "}{formatNumber(tenureData.deferred_amount/100)}
                  </p>
                </div>
              </div>
              <div class="row deferred-text">{`(Payable at the end of ${tenuerMonths} month tenure)`}</div></> : null
              }
              {pd.product_discount > 0 ? (
                <div class="row emi-product-details">
                  <div class="col-7 text-left">
                    <p class="text-green">Product Instant Discount</p>
                  </div>
                  <div class="col-5 text-right">
                    <p class="text-green"> ₹{" "}{formatNumber(pd.product_discount / 100)}</p>
                  </div>
                </div>
              ) : null}
              {pd.subvention_cashback_discount > 0 ? (
                <div class="row emi-product-details">
                  <div class="col-7 text-left">
                    <p class="text-green">EMI Discount/Cashback </p>
                  </div>
                  <div class="col-5 text-right">
                    <p class="text-green">
                    -{" "}₹{" "}{formatNumber(pd.subvention_cashback_discount / 100)}
                    </p>
                  </div>
                </div>
              ) : null}

              {!this.is_IRCTC?<>
              {pd.additional_cashback ? (
                <div class="row emi-product-details">
                  <div class="col-7 text-left">
                    <p class="text-green">Additional Cashback</p>
                  </div>
                  <div class="col-5 text-right">
                    <p class="text-green">

                      {pd.additional_cashback}
                    </p>
                  </div>
                </div>
              ) : null}
              </>:<></>}
              <hr/>
              <div class="row emi-deferred-total-amount">
                <div class="col-7 text-left">
                  <p>Total EMI for {tenuerMonths} months </p>
                </div>
                <div class="col-5 text-right">
                  {isSplitEmi ? <p>
                    {" "}
                    ₹
                    {" "}
                    {formatNumber((tenureData.monthly_installment/100) * tenuerMonths)}
                  </p> : <p>
                    {" "}
                    ₹
                    {" "}
                    {formatNumber((product_amount +
                      pd.bank_interest_rate -
                      pd.product_discount -
                      pd.subvention_cashback_discount) /
                      100)}
                  </p>}
                </div>
              </div>
              <hr/>
              {isSplitEmi ? <ul class="split-emi-terms">
                <li class="deferred-text-terms">{`${(100 - ConvertValueToPercent(tenureData.deferred_percentage))}% of the transaction amount will be converted into EMI.`}</li>
                <li class="deferred-text-terms">{`Balance ${ConvertValueToPercent(tenureData.deferred_percentage)}% will be payable at the end of ${tenuerMonths} months.`}</li>
              </ul> : ""}
            </div>
          );
        });
      }
    }

    return true ? (
      <PopUp onClose={this.props.onClose} isSummary={true}>
        <>
          <div class="modal-content">
            <div class="modal-body clearfix emi-payment-summary">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 emi-tenure-header">
                <h2>EMI Details</h2>
              </div>
              {dynamicItemLevelEMIdetails}
              {/* <div class="final-price clearfix">
                <div class="col-12 ">
                  <div class="row emi-product-details">
                    <div class="col-7 text-left">
                      <p>Final Price </p>
                    </div>
                    <div class="col-5 text-right">
                      <p>₹4,560</p>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </>
      </PopUp>
    ) : null;
  }
}

const mapStateToProps = state => {
  return {
    sessionExpires: state.merchantPaymentDataFetchingReducer.sessionExpires,
    is_IRCTC: state.merchantPaymentDataFetchingReducer.isIRCTC,  
    token: state.merchantPaymentDataFetchingReducer.token,
    conveniencefee_data: state.merchantPaymentDataFetchingReducer.conveniencefeeData,

  };
};

export default connect(mapStateToProps)(EmiDetails);
